import React from 'react'
import './Banner.css'
function Banner() {
  return (
    <div className='banner'>
       <img id='ad' src='https://static.vecteezy.com/system/resources/thumbnails/004/299/835/small/online-shopping-on-phone-buy-sell-business-digital-web-banner-application-money-advertising-payment-ecommerce-illustration-search-free-vector.jpg' alt='Ad'></img>
    </div>
  )
}

export default Banner